import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo1234.svg'


const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = { class: "header__content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header__left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("h1", null, "Океан слов")
], -1)
const _hoisted_4 = { class: "header__right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "menu__panel-icon" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  ref: "menu",
  class: "menu"
}
const _hoisted_8 = { class: "menu__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ChooseLang = _resolveComponent("ChooseLang")!

  return (_ctx.isAuth)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLink && _ctx.handleLink(...args))),
              class: "root-link header-link"
            }, _toDisplayString(_ctx.t("header.profile")), 1),
            _createVNode(_component_router_link, {
              class: "root-link header-link",
              to: "/dictionary",
              tag: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("header.dictionary")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "root-link header-link",
              to: "/folders",
              tag: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("header.sections")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "root-link header-link",
              to: "/accounts",
              tag: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("header.users")), 1)
              ]),
              _: 1
            }),
            _createElementVNode("p", {
              class: "root-link header-link",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, _toDisplayString(_ctx.t("header.logout")), 1),
            _createVNode(_component_ChooseLang)
          ]),
          _createElementVNode("div", {
            ref: "panelLogo",
            class: "menu__panel",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPanel && _ctx.openPanel(...args)))
          }, _hoisted_6, 512),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleLink && _ctx.handleLink(...args))),
                class: "root-link menu-link"
              }, _toDisplayString(_ctx.t("header.profile")), 1),
              _createVNode(_component_router_link, {
                class: "root-link menu-link",
                to: "/dictionary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("header.dictionary")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "root-link menu-link",
                to: "/folders"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("header.sections")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "root-link menu-link",
                to: "/accounts"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("header.users")), 1)
                ]),
                _: 1
              }),
              (_ctx.isAuth)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "root-link menu-link",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, _toDisplayString(_ctx.t("header.logout")), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_ChooseLang)
            ])
          ], 512)
        ])
      ]))
    : _createCommentVNode("", true)
}